module.exports = __webpack_public_path__ + "media/images/icon_burger_menu-b778cb1777612594612f0bf2e4ff8477.svg";